<template>
  <div class="report-page">
    <!--Report Header-->
    <div class="header-container">
      <span class="data-box-title">{{ title }}</span>
    </div>

    <div class="main-area-container">
      <!--Form Area-->
      <report-form-area
        :buttons-disabled="buttonsDisabled"
        :generate-button="generateButton"
        :data-to-send="dataToSend"
      >
        <template v-slot:fields>
          <slot name="reportForm" />
        </template>

        <template v-slot:customButton>
          <slot name="customButton" />
        </template>
      </report-form-area>

      <!--History Area-->
      <div class="right-side-container scroll-fire-fox">
        <report-history-area
          v-if="historyAvailable"
          :history-filter="historyFilter"
          :selectedWorkspaceUUID="selectedWorkspaceUUID"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ReportFormArea from "./Form/FormArea";
import ReportHistoryArea from "./History/HistoryArea";
import TechnicalLocalForm from "@/components/Home/Forms/ObjectForms/TechnicalLocalForm";

export default {
  name: "ReportPage",

  components: {
    TechnicalLocalForm,
    ReportHistoryArea,
    ReportFormArea
  },

  props: {
    title: {
      type: String,
      required: true
    },

    historyAvailable: {
      type: Boolean,
      default: true
    },

    historyFilter: {
      type: String
    },

    buttonsDisabled: {
      type: Boolean,
      default: true
    },

    generateButton: {
      type: Boolean,
      default: true
    },

    selectedWorkspaceUUID: {
      type: String | undefined,
      required: true
    },

    dataToSend: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.report-page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.report-page .header-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.data-box-title {
  margin: 0;
}
.report-page .header-container .buttons-container {
  width: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: normal;
  align-items: flex-start;
}

.mode-button {
  height: 20px;
  width: auto;
  margin-left: 20px;
  cursor: pointer;
}

.mode-button.active path,
.mode-button.active rect {
  fill: var(--primary-highlight);
}

.mode-tooltip {
  margin-bottom: -10px;
}

.main-area-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.right-side-container {
  width: 100%;
  height: 100%;
  padding: 20px 20px 0 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportPage.vue